var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3451_78477",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 25
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3451_78477)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.60437 17.8186C8.14238 17.8186 7.75134 17.6585 7.43124 17.3384C7.11113 17.0183 6.95108 16.6272 6.95108 16.1652V5.75293C6.95108 5.29094 7.11113 4.89988 7.43124 4.57977C7.75134 4.25966 8.14238 4.09961 8.60437 4.09961H16.2729C16.7349 4.09961 17.1259 4.25966 17.446 4.57977C17.7661 4.89988 17.9262 5.29094 17.9262 5.75293V16.1652C17.9262 16.6272 17.7661 17.0183 17.446 17.3384C17.1259 17.6585 16.7349 17.8186 16.2729 17.8186H8.60437ZM8.60437 16.4467H16.2729C16.3433 16.4467 16.4077 16.4174 16.4664 16.3587C16.525 16.3001 16.5543 16.2356 16.5543 16.1652V5.75293C16.5543 5.68257 16.525 5.61807 16.4664 5.55943C16.4077 5.5008 16.3433 5.47149 16.2729 5.47149H8.60437C8.53401 5.47149 8.46952 5.5008 8.41089 5.55943C8.35225 5.61807 8.32293 5.68257 8.32293 5.75293V16.1652C8.32293 16.2356 8.35225 16.3001 8.41089 16.3587C8.46952 16.4174 8.53401 16.4467 8.60437 16.4467ZM5.4033 21.0196C4.94132 21.0196 4.55027 20.8596 4.23016 20.5394C3.91005 20.2193 3.75 19.8283 3.75 19.3663V7.58213H5.12188V19.3663C5.12188 19.4367 5.15119 19.5012 5.20982 19.5598C5.26846 19.6184 5.33295 19.6478 5.4033 19.6478H14.4437V21.0196H5.4033Z",
    fill: "#1976D2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.acb2b52d378bba662fb1f751ba94ce9c.svg";
export { ForwardRef as ReactComponent };